module.exports = __webpack_public_path__ + "img/Chart1.e7248bea.png";